import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface VaultChatCacheState {
  cache: Record<string, any[]>
  setVaultMedia: (key: string, data: any[]) => void
  getVaultMedia: (key: string) => any[] | undefined
  clearVaultMedia: (key: string) => void
  clear: () => void
}

export const useVaultChatCacheStore = create(
    persist<VaultChatCacheState>(
      (set, get) => ({
        cache: {},
  
        setVaultMedia: (key, data) =>
          set(state => ({
            cache: {
              ...state.cache,
              [key]: data,
            },
          })),
  
        getVaultMedia: key => get().cache[key],
  
        clearVaultMedia: key =>
          set(state => {
            const newCache = { ...state.cache }
            delete newCache[key]
            return { cache: newCache }
          }),
  
        clear: () => set({ cache: {} }),
      }),
      {
        name: 'vault-chat-cache', // everything gets persisted
      }
    )
  )
  